















































































































































































































import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { AxiosVue } from '@/AxiosVue';
import { ServicioProxy, TipoAlertaBase } from '@/config/enums';
import config from '@/config/index';
import { Validator } from 'vee-validate';
import { LoadingService } from '@/services/loadingService';
import { Snotify } from '@/snotify/Snotify';
import { FormFieldDefMap } from '@/reusable/Form/formUtils';
import FormFieldsContainer from '@/reusable/Form/FormFieldsContainer.vue';
import DatePicker from '@/reusable/Form/DatePicker.vue';

import { CampoDinamico, AlertaVehiculo } from '@/interfaces/Alertas';

import {
  typeNuevosCampo,
  AlertasBaseBackend,
} from '@/pantallas/ConfigurarBase/ConfiguracionBase';

@Component({
  components: {
    FormFieldsContainer,
    DatePicker,
  },
})
export default class ValoresObtenidosForm extends Vue {
  @Prop({ required: true }) lstAlertasBase: AlertasBaseBackend[];
  @Prop({ required: true }) alertaVehiculo: AlertaVehiculo;

  isFormValid: boolean = false;
  axios: AxiosVue = new AxiosVue(ServicioProxy.Alerta);
  readonly $snotify: Snotify;
  loadingService = new LoadingService();

  lstCampos: typeNuevosCampo[] = [];
  tipoBase: number = -1;

  muestraAlertaGenerica: boolean = false;
  muestraAlertaZona: boolean = false;
  muestraAlertaRuta: boolean = false;
  muestraAlertaVelocidad: boolean = false;
  muestraAlertaUsoNoAutorizado: boolean = false;
  muestraAlertaDetencionNoAutorizada: boolean = false;

  formFields: FormFieldDefMap = {
    fecha: {
      label: 'Fecha Alerta',
      id: 'fecha',
      value: null,
    },
    hora: {
      label: 'Hora Alerta',
      id: 'hora',
      value: null,
    },
    velocidad: {
      label: 'Velocidad en km/h',
      id: 'velocidad',
      value: '',
    },
    tolerancia: {
      label: 'Tolerancia en km/h',
      id: 'tolerancia',
      value: '',
    },
    velocidadIgnicion: {
      label: 'Velocidad en km/h',
      id: 'velocidadIgnicion',
      value: '',
    },
    ubicacion: {
      label: 'Ubicación',
      id: 'ubicacion',
      value: '',
    },
    heading: {
      label: 'Heading (Dirección)',
      id: 'heading',
      value: '',
    },
    peakVelocidad: {
      label: 'Peak de Velocidad',
      id: 'peakVelocidad',
      value: '',
    },
    conductor: {
      label: 'Conductor',
      id: 'conductor',
      value: '',
    },
    flota: {
      label: 'Flota',
      id: 'flota',
      value: '',
    },
    minutos: {
      label: 'Minutos',
      id: 'minutos',
      value: '',
    },
    zona: {
      label: 'Zona',
      id: 'zona',
      value: '',
    },
    fechaActividadFinal: {
      label: 'Fecha Actividad Final',
      id: 'fechaActividadFinal',
      value: null,
    },
    kilometrosAcumulados: {
      label: 'Kilometros Acumulados',
      id: 'kilometrosAcumulados',
      value: '',
    },
    horometroAcumulado: {
      label: 'Horometro Acumulado',
      id: 'horometroAcumulado',
      value: '',
    },
    horaActividadFinal: {
      label: 'Hora Actividad Final',
      id: 'horaActiFinal',
      value: null,
    },
  };

  mounted() {
    this.handleAlertaSeleccionadaChange();
  }

  @Watch('alertaVehiculo', { deep: true })
  handleAlertaSeleccionadaChange() {
    const av = this.alertaVehiculo;
    if (av) {
      this.formFields.fecha.value = av.fechaCreacion;
      this.formFields.hora.value = av.fechaCreacion.format('HH:mm:ss');

      this.handlerChangeTipo(av.alertaBaseId);

      if (this.tipoBase == TipoAlertaBase.AlertaZona || this.tipoBase == TipoAlertaBase.AlertaRuta) {
        this.formFields.velocidad.value = av.velocidadActual;
        this.formFields.ubicacion.value = av.actividad.ubicacion;
        this.formFields.heading.value = av.actividad.heading;
        this.formFields.peakVelocidad.value = av.velocidadMaxima;
        this.formFields.kilometrosAcumulados.value = av.kmAcumulados;
        this.formFields.conductor.value = av.conductor ? av.conductor.nombre : '';
        this.formFields.zona.value = av.zona;
        this.formFields.flota.value = av.flota;
        this.formFields.fechaActividadFinal.value = av.fechaActFin;
        this.formFields.horometroAcumulado.value = av.horometro;
        this.formFields.minutos.value = av.minutos;
        this.formFields.horaActividadFinal.value = av.fechaActFin.format('HH:mm:ss');
      }
    }
  }

  handlerChangeTipo(value: number) {
    this.resetTipoAlerta();
    var alertaBase: AlertasBaseBackend = this.lstAlertasBase.find(
      ab => ab.id == value
    );
    this.tipoBase = alertaBase.baseTipo;

    switch (this.tipoBase) {
      /*case TipoAlertaBase.AlertaGenerica:
        this.mostrarAlertaGenerica(value);
        break;*/
      case TipoAlertaBase.AlertaZona:
        this.muestraAlertaZona = true;
        break;
      case TipoAlertaBase.AlertaRuta:
        this.muestraAlertaRuta = true;
        break;
      case TipoAlertaBase.AlertaUsoNoAutorizado:
        this.muestraAlertaUsoNoAutorizado = true;
        break;
      case TipoAlertaBase.AlertaDetencionNoAutorizada:
        this.muestraAlertaDetencionNoAutorizada = true;
        break;
    }

    if (value === 54) {
      this.muestraAlertaVelocidad = true;
      this.tipoBase = TipoAlertaBase.AlertaZona;
    }
  }

  resetTipoAlerta() {
    this.lstCampos = [];
    this.muestraAlertaGenerica = false;
    this.muestraAlertaZona = false;
    this.muestraAlertaVelocidad = false;
    this.muestraAlertaRuta = false;
    this.muestraAlertaUsoNoAutorizado = false;
    this.muestraAlertaDetencionNoAutorizada = false;
  }

  /* Alerta generica */

  /*mostrarAlertaGenerica(value: number) {
    this.loadingService.showLoading();
    this.axios.http
      .get('Alerta/' + value + '/GetParamAlertaBase')
      .then(res => {
        if (res !== null && res !== undefined) {
          this.lstCampos = res.data;

          if (this.alertaSeleccionada) {
            this.alertaSeleccionada.campoDinamico.forEach(cd => {
              this.lstCampos.forEach(c => {
                if (cd.alertaCampoDinamicoId == c.id) {
                  c.valor = cd.valorCampoDinamico;
                }
              });
            });
          }

          this.muestraAlertaGenerica = true;
        }
      })
      .catch(error => {
        if (error.response !== undefined) {
          if (error.response.status !== 401) {
            this.$snotify.error('Ocurrió un error al obtener los campos.');
          }
        } else {
          this.$snotify.error('Ocurrió un error al obtener los campos.');
        }
      })
      .finally(() => {
        this.loadingService.hideLoading();
      });
  }*/
}
